import { useState, useEffect } from 'react';
import { Gift, Star, TrendingUp, RefreshCw } from 'lucide-react';
import { PageShell, Modal, FG, INP, BtnPrimary, BtnGhost, Spinner, fmtINR, fmtDate, useBanner, useWalletUser } from './WalletShared';
import walletController from '../../controllers/walletController';

const Rewards = () => {
  const { userId } = useWalletUser();
  const { banner, notify, clearBanner } = useBanner();
  const [data,      setData]      = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [showRedeem, setShowRedeem] = useState(false);
  const [points,    setPoints]    = useState('');
  const [saving,    setSaving]    = useState(false);

  const load = async () => {
    setLoading(true);
    const res = await walletController.getRewards(userId);
    if (res.success) setData(res.data);
    else notify('error', res.message);
    setLoading(false);
  };
  useEffect(() => { load(); }, [userId]);

  const handleRedeem = async () => {
    if (!points || Number(points) <= 0) return notify('error','Enter valid points');
    if (Number(points) > (data?.points||0)) return notify('error','Insufficient points');
    setSaving(true);
    const res = await walletController.redeemRewards(userId, Number(points));
    setSaving(false);
    if (res.success) { notify('success', res.message); setShowRedeem(false); setPoints(''); load(); }
    else notify('error', res.message);
  };

  if (loading) return <div style={{ display:'flex', justifyContent:'center', alignItems:'center', minHeight:'60vh', gap:10, color:'#64748b' }}><Spinner size={28}/></div>;

  return (
    <PageShell title="Rewards & Cashback" subtitle="Your earned rewards and cashback" icon={Gift}
      banner={banner} onCloseBanner={clearBanner}
      actions={<button onClick={() => setShowRedeem(true)} style={{ display:'flex', alignItems:'center', gap:5, padding:'7px 14px', background:'#f59e0b', color:'#fff', border:'none', borderRadius:8, fontSize:12, fontWeight:600, cursor:'pointer' }}><Gift size={14}/>Redeem Points</button>}>

      {/* Points hero */}
      <div style={{ background:'linear-gradient(135deg,#f59e0b,#d97706)', borderRadius:14, padding:'24px 22px', marginBottom:20, color:'#fff', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div>
          <div style={{ fontSize:12, opacity:.8, marginBottom:4 }}>Total Points</div>
          <div style={{ fontSize:44, fontWeight:700 }}>{(data?.points||0).toLocaleString('en-IN')}</div>
          <div style={{ fontSize:13, opacity:.8, marginTop:4 }}>≈ {fmtINR((data?.points||0)*0.1)} cashback value</div>
        </div>
        <Star size={60} color="rgba(255,255,255,.2)" fill="rgba(255,255,255,.2)"/>
      </div>

      {/* Stats */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))', gap:12, marginBottom:20 }}>
        {[
          { label:'Points Earned',   value:(data?.totalEarned||0).toLocaleString('en-IN'), color:'#15803d' },
          { label:'Points Redeemed', value:(data?.totalRedeemed||0).toLocaleString('en-IN'), color:'#6d28d9' },
          { label:'Cashback Value',  value:fmtINR(data?.cashbackValue||0), color:'#92400e' },
          { label:'Expiring Soon',   value:(data?.expiringSoon||0).toLocaleString('en-IN'), color:'#b91c1c' },
        ].map((s,i) => (
          <div key={i} style={{ background:'#fff', borderRadius:10, padding:'14px 16px', border:'1px solid #f1f5f9' }}>
            <div style={{ fontSize:11, color:'#64748b', marginBottom:4 }}>{s.label}</div>
            <div style={{ fontSize:18, fontWeight:700, color:s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* History */}
      {data?.history?.length>0 && (
        <div style={{ background:'#fff', borderRadius:12, border:'1px solid #f1f5f9', overflow:'hidden' }}>
          <div style={{ padding:'14px 18px', borderBottom:'1px solid #f1f5f9', fontSize:14, fontWeight:700, color:'#1e293b' }}>Reward History</div>
          {data.history.map((h,i) => (
            <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'11px 18px', borderBottom:'1px solid #f8fafc', fontSize:13 }}>
              <div>
                <div style={{ fontWeight:500, color:'#1e293b' }}>{h.description}</div>
                <div style={{ fontSize:11, color:'#94a3b8' }}>{fmtDate(h.createdAt)}</div>
              </div>
              <span style={{ fontWeight:700, color:h.type==='earn'?'#15803d':'#6d28d9' }}>
                {h.type==='earn'?'+':'-'}{h.points} pts
              </span>
            </div>
          ))}
        </div>
      )}

      {showRedeem && (
        <Modal title="Redeem Points" onClose={() => setShowRedeem(false)}
          footer={<><BtnGhost onClick={() => setShowRedeem(false)}>Cancel</BtnGhost><BtnPrimary onClick={handleRedeem} disabled={saving}>{saving?<><Spinner size={13}/>Redeeming…</>:<><Gift size={13}/>Redeem</>}</BtnPrimary></>}>
          <div style={{ background:'#fef9f0', borderRadius:8, padding:'12px 14px', fontSize:13, color:'#92400e' }}>
            Available: <strong>{(data?.points||0).toLocaleString('en-IN')} points</strong> = {fmtINR((data?.points||0)*0.1)} cashback
          </div>
          <FG label="Points to Redeem *">
            <INP type="number" min="1" max={data?.points||0} value={points} onChange={e => setPoints(e.target.value)} placeholder="Enter points"/>
            {points>0 && <span style={{ fontSize:11, color:'#92400e' }}>= {fmtINR(Number(points)*0.1)} cashback</span>}
          </FG>
        </Modal>
      )}
    </PageShell>
  );
};
export default Rewards;